import { NgControl } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
  selector: '([formControlName], [formControl])[disabledControl]',
})
export class DisabledControlDirective {
  @Input() set disabledControl(condition: boolean) {
    this.ngControl?.valueAccessor?.setDisabledState(condition);
  }

  constructor(private ngControl: NgControl) {}
}
